export enum Role {
    'admin' = 0,
    'moderator' = 1,
    'user' = 2,
}
